import React from "react"

import { LiveSessionsListScreen } from "../../../ports/primary/ui/screens/parent/LiveSessions/LiveSessionsListScreen"
import { useJoinLiveAsChild } from "./useJoinLiveAsChild"

/**
 * Enveloppe legacy de « Tous mes lives » (ports) — porte « Rejoindre en tant que … ».
 *
 * Même raison d'être que `ParentHomeWithExtraHours` : la bascule de compte et l'intention de
 * navigation vivent dans `src/common/**`, que `ports/**` n'importe pas. L'écran ne reçoit qu'un
 * rappel, et son absence éteint la ligne dans la feuille d'actions.
 *
 * Elle existe à côté du pont, et pas DANS lui, parce que le pont doit rester sans hook avant sa
 * branche (`ports/CLAUDE.md` § 6) : le crochet ne tourne donc que sur le chemin du design system,
 * que `parentOnlyBridge` ne monte qu'en mode parent — l'élève et le tuteur, qui empruntent la
 * même route, ne voient jamais ce geste.
 */
export const LiveSessionsListWithJoin = (props) => {
    const { joinLiveAsChild } = useJoinLiveAsChild()

    return (
        <LiveSessionsListScreen
            route={props.route}
            onJoinAsChild={joinLiveAsChild}
        />
    )
}

export default LiveSessionsListWithJoin
